import { Route, Switch, useHistory } from 'react-router-dom';
import routerPaths from './util/routerPaths';
import Page404 from './Page404';
import Welcome from './Welcome';
import ErrorPane from './ErrorPane';
import Login from './home/Login';
import ActivateLicense from './ActivateLicense';
import HybridFlow from './hybrid/HybridFlow';
import UpdateBillingProfile from './skypeSetup/UpdateBillingProfile';
import Settings from './settings/Settings';
import { ProviderHybrid } from './providers/ProviderHybrid';
import { useAuth } from './hooks/useAuth';
import Status from './home/Status';
import { ProviderPrompts } from './providers/ProviderPrompts';
import LoadingMessage from './settings/utils/LoadingMessage';
import RequestTrialForm from './RequestTrialForm';
import { TRIALS_ENABLED } from '../util/config';
import { useErrorPage } from './hooks/useErrorPage';

function ContentPane() {
  const data = useAuth();
  const history = useHistory();
  useErrorPage(history, data);

  const updateData = async () => {
    await data.getTenantProfile();
    history.push(routerPaths.HOME);
  };

  const style = {
    float: 'left',
    paddingLeft: '50px',
    paddingRight: '50px',
    paddingBottom: '500px',
    borderLeft: '1px solid #dbdddf',
    width: '100%',
    minWidth: '350px',
    minHeight: 'calc(100vh - 100px)',
  };

  return (
    <div style={style}>
      <Welcome />
      {!data?.action && !data?.tenant && (
        <LoadingMessage spinnerSize="sm" fontSize="1em" />
      )}
      <Switch>
        <Route exact path={routerPaths.HOME}>
          <Status />
        </Route>
        <Route exact path={routerPaths.LOGIN}>
          <Login />
        </Route>
        <Route path={routerPaths.ACTIVATE_LICENSE}>
          <ActivateLicense onComplete={updateData} />
        </Route>
        <Route path={routerPaths.HYBRID_FLOW}>
          <ProviderHybrid>
            <HybridFlow onComplete={updateData} onCancel={updateData} />
          </ProviderHybrid>
        </Route>
        <Route path={routerPaths.BILLING_PROFILE}>
          <UpdateBillingProfile onComplete={updateData} />
        </Route>
        <Route path={routerPaths.SETTINGS}>
          <ProviderPrompts>
            <Settings />
          </ProviderPrompts>
        </Route>
        {TRIALS_ENABLED && (
          <Route path={routerPaths.REQUEST_TRIAL}>
            <RequestTrialForm onComplete={updateData} onCancel={updateData} />
          </Route>
        )}
        <Route exact path={routerPaths.ERROR}>
          <ErrorPane apiResponse={data} />
        </Route>
        <Route>
          <Page404 />
        </Route>
      </Switch>
    </div>
  );
}

export default ContentPane;
